<template>
  <div>
    <SnackbarError
      :isVisible="invalidDateRange"
      :hideError="onSnackbarClose"
      :error="error"
    />
    <div class="container col-lg-8 col-sm-12">
      <div v-if="isFetchingReports">
        <v-skeleton-loader v-for="i in 10" :key="i" type="list-item" />
      </div>
      <Permissioned section="reports" vertical v-else>
        <ReportListItem
          @validate="validate"
          v-for="report in reports"
          :key="report.id"
          :report="report"
          :dateFrom="dateFrom"
          :dateTo="dateTo"
          :permission="checkPermission(report.title)"
        />
      </Permissioned>
    </div>
  </div>
</template>

<script>
import Permissioned from "@/components/common/Permissioned";
import SnackbarError from "@/components/common/SnackbarError";
import ReportListItem from "@/components/reports/ReportListItem";
import { createNamespacedHelpers } from "vuex";
import { REPORTS_NAMESPACE } from "@/store/modules/reports";
import { FETCH_REPORTS } from "@/store/modules/reports/action-types";

const { mapState, mapActions } = createNamespacedHelpers(REPORTS_NAMESPACE);

export default {
  name: "Reports",
  components: {
    ReportListItem,
    Permissioned,
    SnackbarError
  },
  props: {
    dateRange: Array
  },
  data() {
    return {
      invalidDateRange: false,
      error: {
        title: `Invalid Date`,
        detail: `Please select correct Date Range`
      }
    };
  },
  created() {
    this.fetchReports();
  },
  computed: {
    ...mapState({
      reports: state => state.reports,
      isFetchingReports: state => state.isFetchingReports
    }),
    dateFrom() {
      return this.dateRange ? this.dateRange[0] : null;
    },
    dateTo() {
      return this.dateRange ? this.dateRange[1] : null;
    }
  },
  methods: {
    ...mapActions({
      fetchReports: FETCH_REPORTS
    }),
    onDateChange(val) {
      this.dateFrom = val[0];
      this.dateTo = val[1];
    },
    checkPermission(permissionTitle) {
      switch (permissionTitle) {
        case `WTR Report`:
          return ``;
        case `Agency Request Status Report`:
          return `agency-request-status`;
        case `Employment Intermediary Report`:
          return `employment-intermediary`;
        case `Finance Report`:
          return `finance`;
        case `Timesheet Status & Exceptions Report`:
          return `timesheet-status-and-exceptions`;
        case `Candidate Compliance Report`:
          return `candidate-compliance`;
        case `Agency Timesheet Status & Exceptions Report`:
          return `timesheet-status-and-exceptions-agency`;
        default:
          return ``;
      }
    },
    async validate() {
      this.invalidDateRange = true;
      await new Promise(() =>
        setTimeout(() => {
          this.onSnackbarClose();
        }, 2000)
      );
    },
    onSnackbarClose() {
      this.invalidDateRange = false;
    }
  }
};
</script>

<style lang="scss"></style>
